export default class Selector {
  constructor(options) {
    this.selection = options.selection
    this.required = options.required
  }
}
